module.exports = "<div ui-view=main></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/settings/masterdata/masterdata.html
// module id = 472
// module chunks = 0